import { MutationTree } from "vuex";

import {
  BusinessState,
  Business,
  BusinessList,
} from "@/modules/businesses/types";
import { ApplicantList } from "@/modules/applicants/types";

const mutations: MutationTree<BusinessState> = {
  setBusinesses(state, businesses: BusinessList) {
    state.businesses = businesses;
  },
  setSelectedBusiness(state, selectedBusiness: Business) {
    state.selectedBusiness = selectedBusiness;
  },
  setIsViewing(state, isViewing) {
    state.isViewing = isViewing;
  },
  setAllApprovedBusinesses(state, businesses: BusinessList) {
    state.allApprovedBusinesses = businesses;
  },
  setAllRejectedBusinesses(state, businesses: BusinessList) {
    state.allRejectedBusinesses = businesses;
  },
  setAllPendingBusinesses(state, businesses: BusinessList) {
    state.allPendingBusinesses = businesses;
  },
  //Current Business being viewed
  setCurrentBusiness(state, currentBusiness: Business) {
    state.currentBusiness = currentBusiness;
  },
  setCurrentBusinessOwners(state, currentBusinessOwners: ApplicantList) {
    state.currentBusinessOwners = currentBusinessOwners;
  },
  // Sorting
  setSortOrder(state, sortOrder) {
    state.sortOrder = sortOrder;
  },
  setSortBy(state, sortBy) {
    state.sortBy = sortBy;
  },
  setIsFetchingBusinesses(state, isFetchingBusinesses) {
    state.isFetchingBusinesses = isFetchingBusinesses;
  },
  setIsFetchingBusinessOwners(state, isFetchingBusinessOwners) {
    state.isFetchingBusinessOwners = isFetchingBusinessOwners;
  },
  setQuery(state, query) {
    state.query = query;
  },
};

export default mutations;
